module.exports = __webpack_public_path__ + "media/images/woman-profile-3-d47865172f1dbc75d7787fc879d0e739.jpeg";